var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 4,
    viewBox: "0 0 15 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 2.82842 2.32842 3.5 1.5 3.5C0.67158 3.5 0 2.82842 0 2C0 1.17158 0.67158 0.5 1.5 0.5C2.32842 0.5 3 1.17158 3 2Z",
    fill: "#999B9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C9 2.82842 8.32842 3.5 7.5 3.5C6.67158 3.5 6 2.82842 6 2C6 1.17158 6.67158 0.5 7.5 0.5C8.32842 0.5 9 1.17158 9 2Z",
    fill: "#999B9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2C15 2.82842 14.3284 3.5 13.5 3.5C12.6716 3.5 12 2.82842 12 2C12 1.17158 12.6716 0.5 13.5 0.5C14.3284 0.5 15 1.17158 15 2Z",
    fill: "#999B9F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBtn);
export default __webpack_public_path__ + "static/media/menuBtn.e66625c7db2053d156cc4c2362a95421.svg";
export { ForwardRef as ReactComponent };